import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import isEqual from 'lodash-es/isEqual'
import $ from '../../static/chart/jquery' // eslint-disable-line

import ChartContainer from './ChartContainer'
import { initDepthChart } from '../../utils/chart'
import DetectElementResize from '../../utils/detectElementResize'
import LoadingShade from '../../components/common/LoadingShade'
import isElectron from '../../utils/isElectron'

const DEPTH_VIEW_NAME = 'depth'

const Container = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.exchangeSecondBg};
`

class DepthChartRenderer extends Component {
  static propTypes = {
    book: PropTypes.object,
    hidden: PropTypes.bool.isRequired,
    selectedView: PropTypes.string,
    fullScreen: PropTypes.bool,
    interval: PropTypes.number,
    openOrders: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    symbol: PropTypes.string.isRequired,
  }

  static defaultProps = {
    book: {},
    selectedView: 'default',
    fullScreen: false,
    interval: 60,
    openOrders: [],
  }

  componentDidMount() {
    DetectElementResize.addResizeListener(
      this._depthChartContainer.current,
      (this._resizeHandler = () => {
        this._depth && this._depth.resize()
      })
    )
  }

  // shouldComponentUpdate({ selectedView, book, symbol, interval, theme }) {
  //   const { book: currentBook, selectedView: currentSelectedView } = this.props
  //   if (!isEqual(book, currentBook)) {
  //     return true
  //   }

  //   const depthIsNow = currentSelectedView === DEPTH_VIEW_NAME;
  //   const depthIsNext = selectedView === DEPTH_VIEW_NAME;
  //   // depth is next or we are leaving depth (so hide it)
  //   return depthIsNext ||
  //     (depthIsNow && !depthIsNext) ||
  //     // symbol or interval changed, update chart even if hidden
  //     (!!this._depth && symbol !== this.props.symbol) ||
  //     (!!this._depth && interval !== this.props.interval) ||
  //     (!!this._depth && theme !== this.props.theme);
  // }

  componentDidUpdate({ openOrders: prevOpenOrders }) {
    const { book, selectedView, openOrders } = this.props

    if (this._depth && !isEqual(openOrders, prevOpenOrders)) {
      this._userOrdersOndepth(openOrders)
    }

    if (!window.UserAccount_Class && !window.VisualDepth) return

    if (selectedView !== DEPTH_VIEW_NAME) return

    this._init()

    // update the "depth" chart
    if (book && (book.asks || book.bids)) {
      let newAsks = this._parsedAsks
      let newBids = this._parsedBids

      if (!newAsks || this._lastAsks !== book.asks) {
        newAsks = this._parsedAsks = book.asks.reduce((obj, ask) => {
          const [price, amount] = ask
          obj[price] = amount
          return obj
        }, {})
      }

      if (!newBids || this._lastBids !== book.bids) {
        newBids = this._parsedBids = book.bids.reduce((obj, ask) => {
          const [price, amount] = ask
          obj[price] = amount
          return obj
        }, {})
      }

      this._lastAsks = book.asks
      this._lastBids = book.bids
      window.OBD.loadBook(newAsks, newBids, 100)
    } else {
      window.OBD.loadBook([], [], 100)
    }
  }

  componentWillUnmount() {
    this._resizeHandler &&
      DetectElementResize.removeResizeListener(
        this._depthChartContainer.current,
        this._resizeHandler
      )
    try {
      this._depth && this._depth.unload()
    } catch (err) {
      console.log('Depth chart unmount exception ignored!', err)
    }
  }

  _init() {
    const { symbol } = this.props
    const quoteAsset = symbol.split('_')[1]
    // init depth chart if not yet done
    if (!this._depth) {
      console.log('Init depth chart.')
      this._depth = initDepthChart({
        themeName: isElectron() ? 'depth-white' : 'depth-black-bnb',
        containerEl: this._depthChartContainer.current,
        symbol,
        quoteAsset,
      })
    }
  }

  _depthChartContainer = React.createRef()

  _userOrdersOndepth(data) {
    if (data && data instanceof Array) {
      const obj = {}
      obj.exch = 'BIJIE'
      obj.orders = []
      data.forEach(d => {
        const [, quoteAsset] = d.symbol.split('_')
        if (d.symbol === this.props.symbol) {
          obj.orders.push({
            id: d.orderId,
            action: d.side === 1 ? 'buy' : 'sell',
            amount: d.quantity,
            price: d.price,
            base: d.symbol,
            quote: quoteAsset,
            status: 'Open',
          })
        }
      })
      window.UserAccount.ordersAdd(obj)
    }
  }

  render() {
    const { selectedView, fullScreen, book } = this.props
    return (
      <ChartContainer
        ref={this._depthChartContainer}
        hidden={selectedView !== DEPTH_VIEW_NAME}
        fullScreen={fullScreen}
        selectedView={selectedView}
      >
        <LoadingShade hidden={!!book} />
        <Container className="box-inner" />
      </ChartContainer>
    )
  }
}

const mapStateToProps = ({ orderBooks, exchange: { currentTrade }, order: { openOrders } }) => ({
  book: orderBooks && orderBooks[currentTrade],
  openOrders,
  symbol: currentTrade,
})

export default connect(mapStateToProps)(DepthChartRenderer)
